<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="docForm.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="docForm">
        <div class="form-group row">
          <mat-form-field class="">
            <mat-label>Nom</mat-label>
            <input matInput placeholder="" type="text" required formControlName="name" />
            <mat-error>
              <span *ngIf="f('name').hasError('required')">Veuillez saisir un nom</span>
              <span *ngIf="f('name').hasError('maxlength')">Le nom ne doit pas dépasser 50 caractères</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group row">
          <mat-form-field class="">
            <mat-label>Description</mat-label>
            <textarea matInput placeholder="" formControlName="description"></textarea>
            <mat-error>
              <span *ngIf="f('description').hasError('maxlength')">La description ne doit pas dépasser 160
                caractères</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="canIdentifyDocument" class="form-group row">
          <mat-radio-group [value]="mode" (change)="updateMode($event)">
            <mat-radio-button value="categorize">Catégoriser</mat-radio-button>
            <mat-radio-button value="identify">Identifier</mat-radio-button>
          </mat-radio-group>
        </div>

        <ng-container *ngIf="mode==='categorize'">
          <div class="form-group row">
            <mat-form-field class="">
              <mat-label>Catégorie</mat-label>
              <mat-select formControlName="category" required placeholder="">
                <mat-option *ngFor="let categ of categories" [value]="categ">
                  {{ categoriesName[categ] }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group row">
            <mat-form-field class="">
              <mat-label>Type</mat-label>
              <mat-select formControlName="type" required placeholder="">
                <mat-option *ngFor="let docType of types" [value]="docType">
                  {{ typesName[docType] }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="showLinkedObject" class="form-group row">
            <mat-form-field class="">
              <mat-label>Lier à</mat-label>
              <mat-select placeholder="" formControlName="linkObjectId">
                <mat-option>Aucun</mat-option>
                <mat-option *ngFor="let linkObject of linkedObjects" [value]="linkObject.uid">
                  {{ linkObject.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
        <div *ngIf="mode==='identify'" class="form-group row">
          <mat-form-field class="">
            <mat-label>Identifiant</mat-label>
            <mat-select formControlName="identifier" required placeholder="">
              <mat-option *ngFor="let id of identifiers" [value]="id">
                {{ identifiersName[id] }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</ng-template>